import { createApi } from '@reduxjs/toolkit/query/react';
import { Response } from '../../models/shared';
import { CrmSummaryDTO } from '../../models/crm';
import baseQueryWithReauth from './base';

const crmApi = createApi({
  reducerPath: 'crmApi',
  baseQuery: baseQueryWithReauth,
  tagTypes: ['crm-summary'],
  endpoints: (build) => ({
    // ROOT only. The backend caches it for 5 minutes, so polling more often is pointless.
    getCrmSummary: build.query<CrmSummaryDTO, void>({
      query: () => ({ url: 'crm/summary' }),
      transformResponse: (response: Response<CrmSummaryDTO>): CrmSummaryDTO => response.data ?? { available: false },
      providesTags: ['crm-summary'],
    }),
  }),
});

export const { useGetCrmSummaryQuery } = crmApi;
export { crmApi };
